import { useTranslation } from 'react-i18next'
import { Box, Text, Stack } from '@machobear/design-system'
import formatDate from '@/utils/format-date'
import { StyledTableCell } from '@/components/listings-table'
import { MobileRowWrapper, MobileUnitDetails, MobileUnitText } from '@/components/listings-table'
import { RenderBadge } from './trustscore-status'
import { OptionsMenu } from './options-menu'
import { Favourite } from './favourite-column'
import { Modals } from '../types'

type TrustScoreRowProps = {
  trustScoreInfo: any
  showModal: (modal: keyof Modals) => () => void
  setDeleteId: (deleteId: string) => void
  favouriteTrustScore: () => void
}

export const MobileTrustScoreRow = ({
  trustScoreInfo,
  showModal,
  setDeleteId,
  favouriteTrustScore
}: TrustScoreRowProps) => {
  const { t } = useTranslation()
  return (
    <>
      <StyledTableCell width="80%" top={20}>
        <Box display="flex" flexDirection="row" gap="xsmall">
          <Favourite trustScoreInfo={trustScoreInfo} favouriteTrustScore={favouriteTrustScore} />

          <MobileRowWrapper marginLeft={0}>
            <MobileUnitDetails top="0">
              <Stack space="small">
                <Box display="flex" alignItems="center">
                  <Text weight="medium">{trustScoreInfo?.name}</Text>
                </Box>
                <Stack space="xsmall">
                  <Box display="flex" alignItems="center" gap="xxsmall">
                    <Text size="small">
                      {t('l.listing.application.liv_score.text', 'Trust Score')}:{' '}
                    </Text>
                    <Text size="small">
                      {trustScoreInfo?.trust_score !== null
                        ? `${trustScoreInfo?.trust_score}/${trustScoreInfo?.max_trust_score}`
                        : 'N/A'}
                    </Text>
                  </Box>
                  <Box display="flex" alignItems="center" gap="xxsmall">
                    <Text size="small">
                      {t(
                        'l.standalone_trustscore.list.table.header_cell.last_updated',
                        'Last Updated'
                      )}
                      :{' '}
                    </Text>
                    <Text size="small">
                      {trustScoreInfo?.last_updated !== null
                        ? formatDate(trustScoreInfo?.last_updated, 'MMM D, YYYY')
                        : 'N/A'}
                    </Text>
                  </Box>
                </Stack>
              </Stack>
            </MobileUnitDetails>
          </MobileRowWrapper>
        </Box>
      </StyledTableCell>

      <StyledTableCell width="25%" verticalAlign="top">
        <Box
          display="flex"
          flexDirection="row"
          gap="xsmall"
          alignItems="center"
          paddingTop="medium"
          justifyContent="flexEnd"
          marginRight="gutter"
        >
          <RenderBadge status={trustScoreInfo?.status} />
          <MobileUnitText justifyContent>
            <OptionsMenu
              trustScoreInfo={trustScoreInfo}
              showModal={showModal}
              setDeleteId={setDeleteId}
            />
          </MobileUnitText>
        </Box>
      </StyledTableCell>
    </>
  )
}
